import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const InvoicejournalVoucher = (props) => {

    const { journalVoucher, setJournalVoucher, remaining } = props;

    const { api, userData, settingData, accountData, warehouseData, selectedCompany,
        productData, refData, branchData, projectData, currencyData } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const { showModal, toggleModal, table, title, refreshTable, size, footer, idRow, type } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);






    // Account Options
    const accountOptions = accountData?.map(item => ({
        value: item.id,
        label: `${item.chartId}.${item.accountId} ${item.name}`,
        name: item.name,
    }));

    // Load and filter account options
    const loadAccountOptions = (inputValue, callback) => {
        const filteredOptions = inputValue ? accountOptions.filter(option =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];

        filteredOptions.push({ value: null, label: 'no supplier' });
        callback(filteredOptions);
    };

    // Currency Options
    const currencyOptions = currencyData?.map(item => ({
        value: item.id,
        label: item.code,
        symbol: item.symbol,
        rate: item.rate,
        vatRate: item.vatRate,
    }));


    // Generic handler for input changes
    const handleInputChange = (e, type) => {
        let { name, value } = e.target;
        if (isNaN(value)) {
        } else {
            value = parseFloat(value);
        }

        setJournalVoucher((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (name == 'debit') {
            setJournalVoucher((prev) => ({
                ...prev,
                credit: value,
            }));
        }
    };




    // handle select change
    const handleSelectChange = (selectedOption, name) => {
        setJournalVoucher((prev) => ({
            ...prev,
            [name]: selectedOption.value,
        }));

        if (name == 'currencyId') {
            setJournalVoucher((prev) => ({
                ...prev,
                rate: selectedOption.rate,
                vatRate: selectedOption.vatRate,
            }));
        }
    };



    return (

        <div>


            <Row className="mb-3">


                <Col md={6}>
                    <Form.Label>Currency<span style={{ color: 'red' }}>*</span></Form.Label>
                    <Select
                        options={currencyOptions}
                        isSearchable={true}
                        placeholder="Select"
                        onChange={(e) => handleSelectChange(e, 'currencyId')}
                        value={currencyOptions?.find(option => option.value === journalVoucher.currencyId) || []}
                        required
                    />
                </Col>

                <Col>
                    <Form.Label>Rate<span style={{ color: 'red' }}>*</span></Form.Label>
                    <Form.Control type="number" name="rate"
                        onChange={(e) => handleInputChange(e)}
                        value={journalVoucher.rate}
                        required
                    />
                </Col>
            </Row>

            <Row className="mb-3">


                <Col>
                    <Form.Label column="sm" sm="4">
                        PaymentType
                    </Form.Label>
                    <Form.Select name="paymentType"
                        value={journalVoucher.paymentType}
                        onChange={(e) => handleInputChange(e, 'text')}
                    >
                        <option value={'cash'}>Cash</option>
                        <option value={'onAccount'}>onAccount</option>
                    </Form.Select>
                </Col>

                <Col>
                    <Form.Label>Amount<span style={{ color: 'red' }}>*</span></Form.Label>
                    <Form.Control type="number" name="debit"
                        onChange={(e) => handleInputChange(e)}
                        value={journalVoucher.debit}
                        required
                    />
                </Col>
            </Row>


        </div>

    )
}


export default InvoicejournalVoucher;